import React, { useState, useEffect, Component } from 'react';
import {
  Alert,
  Button,
  KeyboardAvoidingView,
  ScrollView,
  Text,
  TextInput,
  View,
} from 'react-native';
import Styles from './styles';
import Config from './config';
import Hermes from './hermes';

export default function LoginView({ navigation }) {
  const WordsURL = `${Config.Scheme}://${Config.Domain}/words`;

  var [username, setUsername] = useState('');
  var [password, setPassword] = useState('');
  var [authorized, setAuthorized] = useState(false);
  var textInputPassword = null;

  const _login = async (navigate) => {
    try {
      const result = await Hermes.fetch(`${Config.Scheme}://${Config.Domain}/login`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        method: "POST",
        body: JSON.stringify({
          user: {
            username: username,
            password: password,
          },
        }),
      });

      if (result.Error == null) {
        setAuthorized(true);
      } else if (result.mode == "demo") {
        setAuthorized(true);
      }
    } catch(error) {
      Hermes.alert(error);
    }

    setUsername('');
    setPassword('');
  }

  const _logout = async () => {
    setAuthorized(false);
  }

  useEffect(async () => {
    try {
      const result = await Hermes.fetch(`${WordsURL}_count`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        method: "GET",
      });

      setAuthorized(true);
    } catch(error) {
      setAuthorized(false);
    }
  }, []);

  const navigate = () => _login(navigate);
  let menu = (
    <View>
      <TextInput
        style={Styles.input}
        onChangeText={setUsername}
        value={username}
        placeholder="Username (email)"
        autoCapitalize='none'
        returnKeyType='next'
        onSubmitEditing={() => textInputPassword.focus()}/>
      <TextInput
        style={Styles.input}
        onChangeText={setPassword}
        value={password}
        placeholder="Password"
        autoCapitalize='none'
        secureTextEntry={true}
        returnKeyType='done'
        onSubmitEditing={navigate}
        ref={(input) => textInputPassword = input}/>
      <View style={{padding: 10}}>
        <Button
          onPress={navigate}
          title="Login"
          color="#841584"
          accessibilityLabel="Logs in"/>
      </View>
    </View>
  );
  if (authorized) {
    menu = (
      <View>
        <View style={{padding: 10}}>
          <Button
            onPress={() => navigation.navigate('Words')}
            title="Goto Words"
            color="#841584"
            accessibilityLabel="Goes to words"/>
        </View>
        <View style={{padding: 10}}>
          <Button
            onPress={() => navigation.navigate('FlashCards')}
            title="Flash Cards"
            color="#841584"
            accessibilityLabel="Goes to words"/>
        </View>
        <View style={{padding: 10}}>
          <Button
            onPress={_logout}
            title="Logout"
            color="#841584"
            accessibilityLabel="Logs out"/>
        </View>
      </View>
    );
  }
  return (
    <View style={Styles.container}>
      <KeyboardAvoidingView behavior={'height'} style={Styles.modal}>
        <ScrollView keyboardShouldPersistTaps='always'>
          {menu}
          <View style={{padding: 10}}>
            <Button
            onPress={() => navigation.navigate('PasswordReset')}
              title="Password Reset"
              color="#841584"
              accessibilityLabel="View password reset form"/>
          </View>
          <View style={{padding: 10}}>
            <Button
              onPress={() => navigation.navigate('AddUser')}
              title="New User"
              color="#841584"
              accessibilityLabel="Logs in"/>
          </View>
          <View style={{height: 40}}></View>
        </ScrollView>
      </KeyboardAvoidingView>
    </View>
  );
}
